export default function StatCard({ label, value, change, changeType = 'up', icon, iconBg }) {
  return (
    <div className="stat-card">
      {icon && (
        <div className="stat-icon" style={{ background: iconBg || '#E1F5EE' }}>
          {icon}
        </div>
      )}
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {change && <div className={`stat-change ${changeType}`}>{change}</div>}
    </div>
  );
}
